import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';

export default class Users extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'user',
            data: null,
            loading: true,
            record: null
        };
    }
    componentDidMount() {
        this.refreshData();
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        this.httpPost("api/v1/user/save", {
            organizationId: this.state.data.global.company.id,

            id: this.state.record.id,
            fname: this.state.record.fname,
            lname: this.state.record.lname,
            password: this.state.record.password,
            mobile: this.state.record.mobile,
            nationalId: this.state.record.nationalId,
            relation: this.state.record.relation,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.refreshData();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    newUser() {
        this.setState({
            record: {
                id: this.defaultGuid(),
                nationalId: '',
                fname: '',
                lname: '',
                password: '',
                mobile: '',
                relation: 1
            }
        })
    }
    removeUser(id) {
        this.state.selectedIds = [id];
        this.setState({ showConfirmRemove: true });
    }
    renderForm() {
        return <div className="container">
            {!this.isNull(this.state.record) && <div className="panel panel-info center-block">
                <form className="ng-pristine">
                    <div className="panel-body">
                        <div className="row">
                            <div className="col-sm-3 col-xs-12">
                                <div className="form-group">
                                    <label className="title1">نام<span className="red">*</span></label>
                                    <input disabled={this.state.record.id != this.defaultGuid()} defaultValue={this.state.record.fname} onChange={e => this.state.record.fname = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="30" />
                                </div>
                            </div>
                            <div className="col-sm-3 col-xs-12">
                                <div className="form-group">
                                    <label className="title1">نام خانوادگی<span className="red">*</span></label>
                                    <input disabled={this.state.record.id != this.defaultGuid()} defaultValue={this.state.record.lname} onChange={e => this.state.record.lname = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="30" />
                                </div>
                            </div>
                            <div className="col-sm-3 col-xs-12">
                                <div className="form-group">
                                    <label className="title1">موبایل<span className="red">*</span></label>
                                    <input disabled={this.state.record.id != this.defaultGuid()} defaultValue={this.state.record.mobile} onChange={e => this.state.record.mobile = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="11" />
                                </div>
                            </div>
                            {1 === 2 && <div className="col-sm-3 col-xs-12">
                                <div className="form-group">
                                    <label className="title1">کدملی<span className="red">*</span></label>
                                    <input disabled={this.state.record.id != this.defaultGuid()} defaultValue={this.state.record.nationalId} onChange={e => this.state.record.nationalId = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="11" />
                                </div>
                            </div>}
                            {1 === 2 && <div className="col-sm-3 col-xs-12">
                                <label className="title1">دسترسی</label>
                                <div className="dropdown">
                                    <select defaultValue={this.state.record.relation} onChange={e => this.state.record.relation = parseInt(e.target.value)} className="form-control input-sm">
                                        <option value="1">ادمین</option>
                                        <option value="2">کاربر</option>
                                    </select>
                                </div>
                            </div>}
                            <div className="col-sm-3 col-xs-12">
                                <div className="form-group">
                                    <label className="title1">کلمه عبور</label>
                                    <input disabled={this.state.record.id != this.defaultGuid()} defaultValue={this.state.record.password} onChange={e => this.state.record.password = e.target.value} autocomplete="off" type="password" className="form-control input-sm" maxlength="100" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="panel-footer">
                        <div>
                            <a onClick={e => this.save(e)} className="btn btn-primary btn-sm" style={{ "width": "80px" }} >ذخیره</a>
                            <a onClick={e => this.setState({ record: null })} className="btn btn-default btn-smoke btn-sm" style={{ "width": "80px" }} >انصراف</a>
                        </div>
                    </div>
                </form>
            </div>}
            <div className="panel panel-info center-block">
                <div className="panel-heading">
                    <span className="panel-title acc-txt-9"><strong>کاربران</strong></span>
                </div>
                <div className="panel-body">
                           <a className="btn btn-info mr-b-10" onClick={e => this.newUser()}>
                        <span className="fa fa-plus" aria-hidden="true"></span>&nbsp;
                        افزودن کاربر جدید                </a>
                    <table className="table table-bordered table-hover">
                        <thead>
                            <tr className="active" style={{ "font-size": "9pt", "font-weight": "bold" }} >
                                <td>نام</td>
                                <td>دسترسی</td>
                                <td>وضعیت</td>
                                <td>آخرین ورود</td>
                                <td></td>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.data.records.map(u =>
                                <tr>
                                    <td>
                                        <strong>{u.fname} {u.lname}</strong>
                                    </td>
                                    <td>{u.relationString}</td>
                                    <td>{u.statusString}</td>
                                    <td>{u.lastLogin}</td>
                                    <td>
                                        <a onClick={e => this.setState({ record: u })} style={{ "color": " gray" }}><i className="fa fa-pencil text-gray"></i></a>
                                        <a onClick={e => this.removeUser(u.id)} style={{ "color": " red","margin-right": "5px" }}><i className="fa fa-trash text-red"></i></a>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            <div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                this.renderForm(),
                this.renderPopupComponent(),
                <Footer />
            ];
        return contents;
    }
}